import { useIsSetupOptionEnabled } from '@/helpers/hooks/useIsSetupOptionEnabled/useIsSetupOptionEnabled';
import { useSetupOption } from '@/helpers/hooks/useSetupOption/useSetupOption';
import { SERVICE } from '@/modules/config';

export const useServiceRequestSetupOption = (setupOption: string) =>
  useIsSetupOptionEnabled(setupOption, SERVICE.SERVICE_REQUEST);

export const useServiceRequestSetupOptionValue = (setupOption: string) =>
  useSetupOption(setupOption, SERVICE.SERVICE_REQUEST);
